/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { asyncConnect } from 'redux-connect';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import commonUtil from '../../../../../utils/commonUtil';
import * as AccountStatusDetailsAction from '../../actions';
import BonusDetailPageWAP from './BonusDetailPageWAP';
import BonusDetailPageWEB from './BonusDetailPageWEB';
import * as labelsActions from '../../../../../components/labels/actions';
import { getEventSummaryInfo } from '../../../../eventManagement/page/GiftList/actions';
import ApplyCSS from '../../../../../components/ApplyCSS';
import Tagging from '../../../../../components/Tagging/Tagging';

const { getBonusDetails, getStatementDetailsForPrintAndDownload } = AccountStatusDetailsAction;
const { isLablesLoaded, loadLables } = labelsActions;
const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])
@connect(store => ({
  content: store.targetterContent.data,
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  { labelsActions })

class BonusDetailPageIndex extends Component {
  constructor(props) {
    super(props);
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    this.getStatementDetailsForPrintAndDownloadData = null;
    this.state = {
      statementPrintAndDownload: null,
    };
  }
  componentDidMount() {
    commonUtil.addTransition();

    let url = this.props.route.path.split('(');
    url = url[0];

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: url,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Detalles de bonificación',
      Site: 'Mesa de Regalos',
      idMesa: this.eventId,
    });
  }
  UNSAFE_componentWillMount() {
    this.props.getBonusDetails(this.eventId);
    this.props.getStatementDetailsForPrintAndDownload(this.eventId);
    if (!_.isEmpty(this.props.state.user.data) && !_.isEmpty(this.props.state.user.data.result)) {
      this.props.getEventSummaryInfo(this.eventId, this.props.state.user.data.result.profileId, this.props.state.user.data.result.emailId);
    }
  }


  render() {
    return (
      <div>
        <Tagging ref={tagging => this.tagging = tagging} />
        <ApplyCSS pageName="accountstatus" />
        {!_.isEmpty(this.props.lables) &&
          !_.isEmpty(this.props.bonusDetailsData) &&
          !_.isEmpty(this.props.eventInfo) ? <div>
            {channel === constChannels.WEB ?
              <BonusDetailPageWEB
                ref={bonusDetailPageWEB => this.bonusDetailPageWEB = bonusDetailPageWEB}
                bonusDetailsData={this.props.bonusDetailsData}
                lables={this.props.lables}
                eventId={this.eventId}
                eventInfo={this.props.eventInfo}
                user={this.props.user}
                accountStatus={this.props.accountStatus}
                statementDetailsForPrintAndDownloadData={this.props.statementDetailsForPrintAndDownloadData}
                printingDate={this.props.printingDate}
              /> :
              <BonusDetailPageWAP
                bonusDetailsData={this.props.bonusDetailsData}
                lables={this.props.lables}
                eventId={this.eventId}
                eventInfo={this.props.eventInfo}
                printingDate={this.props.printingDate}
              />
            }
          </div>

          : null}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  state,
  user: state.user.data,
  lables: state.labels,
  bonusDetailsData: state.accountSummary.bonusDetailsData,
  accountStatus: state.accountSummary.accountStatus,
  eventInfo: state.accountSummary.eventInfo.eventInfo,
  statementDetailsForPrintAndDownloadData: state.accountSummary.statementDetailsForPrintAndDownloadData,
});

const matchDispatchToProps = dispatch => bindActionCreators({ getBonusDetails, getEventSummaryInfo, getStatementDetailsForPrintAndDownload }, dispatch);

export default connect(mapStateToProps, matchDispatchToProps)(BonusDetailPageIndex);

